import { SURVEY_TYPE } from '@src/constants/survey';
import api from './api';

export const getSurveyUser = async () => {
  try {
    const response = await api({
      method: 'GET',
      url: '/surveys/user',
    });
    return response;
  } catch (err) {
    return err.response?.data;
  }
};

export const getSurveys = async (type = SURVEY_TYPE.SIGNUP) => {
  try {
    const response = await api({
      method: 'GET',
      url: `/surveys/type/${type}`,
    });
    return response;
  } catch (err) {
    return err.response?.data;
  }
};

export const updateSurvey = async (data, type = SURVEY_TYPE.SIGNUP) => {
  try {
    const response = await api({
      method: 'POST',
      url: `/surveys/type/${type}`,
      data,
    });
    return response;
  } catch (err) {
    return err.response?.data;
  }
};
